import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const LinkButton = styled.div`
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity: ${props => (props.disabled ? '24%' : '100%')};
  font-weight: 600;
  font-size: 12px;
  color: ${themeGet('colors.primary.100')};
  margin-top: 17px;
  &:hover {
    opacity: 0.8;
  }
`;

export const InputWrapper = styled.div`
  margin-top: 23px;
`;

export const RemoveButton = styled(LinkButton)`
  position: relative;
  top: 14px;
  left: 127px;
  z-index: 1;
`;
